<template>
 
    <ModalLibroMayorDetalle :listDetalle="listDetalle" :totalGastos="totalGastos" :visible="modalVisible"   @update:visible="modalVisible  = $event" />
 
  <div>
 
    <!-- Etiqueta superior -->
     
  <div class="flex justify-start " >     
  <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm"> &lt;CuentaPresupuestos&gt;</span>
</div>
<!-- Tarjeta de cabecera -->
<div
  class="ml-0 grid grid-cols-1 sm:grid-cols-8 gap-4 text-sm
         bg-white p-5 rounded-t-xl shadow-md border border-gray-100
         hover:shadow-lg transition duration-200 items-center"
>
   <div>
    <button v-if="this.$store.state.auth.userLogin.año_borrador 
    && this.$store.state.auth.userLogin.is_admin 
    && !borrador" 
      @click="toggleCuentaBorrador(cuenta.id)"
      :title=this.$store.state.auth.userLogin.año_borrador
      class="flex items-center justify-center  h-7 w-[80px]
             bg-blue-200 text-blue text-xs   shadow
             hover:bg-violet-400  hover:shadow-md
             transition duration-150  rounded-2xl" 
    >
    {{ cuentaExpandidaBorrador.includes(cuenta.id) ? '▲' : '▼' }}  
    </button>
   </div> 
  <!-- Centro -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Centro</div>
    <div class="text-gray-800  font-mono">
        {{ centro.nombre }}
    </div>
  </div>

  <!-- Cuenta -->
  <div >
    <div class="text-xs text-gray-500 uppercase tracking-wide">Cuenta</div>
    <div class="text-gray-900   font-mono">
      {{   cuenta.cod  }} <br> {{ cuenta.nomcta }}
    </div>
  </div>

  <!-- Presupuesto -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Presupuesto  {{ aa_consulta }} </div>
    <div class="text-gray-900   font-mono">
      $ {{ $formatoMiles(cuenta_total_presupuesto) }}
    </div>
  </div>

  <!-- Gastos -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Gastos</div>
    <div class="text-gray-900 font-mono">
      $ {{ $formatoMiles(cuenta.total_gastos) }}
    </div>
  </div>

  <!-- Saldo -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Saldo</div>
    <div class="text-sm  font-mono"
         :class="cuenta.saldo < 0 ? 'text-red-600' : 'text-blue-600'">
      $ {{ $formatoMiles(cuenta.saldo) }}
    </div>
  </div>
 <!-- % ejecucion -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Ejecución</div>
    <div class="text-sm  font-mono"  :class="cuenta.saldo < 0 ? 'text-red-600' : 'text-blue-600'">
         {{
          cuenta_total_presupuesto > 0
            ? ((cuenta.total_gastos / cuenta_total_presupuesto) * 100).toFixed(1)
            : 0
        }}%
    </div>
  </div>
  <!-- Botones -->
  <div class="flex justify-end items-center gap-2">
   
  
   <button v-if="borrador==false"
  @click="editar"
  title="detalle gastos"
  class="flex items-center justify-center w-12 h-12 text-white rounded-full shadow hover:shadow-md transition duration-150"
  :class="borrador 
    ? 'bg-green-700 hover:bg-green-400' 
    : 'bg-violet-700 hover:bg-violet-400'"
>
  $
</button>

    <button
  @click="toggleCuenta(cuenta.id)"
  :title="borrador ? 'detalle presupuesto (borrador)' : 'detalle presupuesto'"
  class="flex items-center justify-center w-12 h-12 text-white rounded-full shadow hover:shadow-md transition duration-150"
  :class="borrador 
    ? 'bg-green-700 hover:bg-green-400' 
    : 'bg-violet-700 hover:bg-violet-400'"
>
  <span class="text-lg leading-none">
    {{ cuentaExpandida.includes(cuenta.id) ? '▲' : '▼' }}
  </span>
</button>

  </div>
    
</div>
    <!-- Sección expandible -->
    <transition name="fade">
     <div>
      <div  
        v-if="revisaExpansionBorrador(cuenta.id)"
        class="mt-0 p-4 bg-gray-50 border border-gray-200 text-sm 
               text-gray-700   shadow-sm animate-fadeIn">
     <div class="flex justify-center">
  <div class="w-full max-w-5xl">

        <IngresosMensualesBorrador 
           v-if="this.$store.state.auth.userLogin.modifica_presupuestos"
          :cuenta_total_presupuesto_aa_abierto="cuenta_total_presupuesto"
          :centro_id="centro.id"
          :propCuenta_id="cuenta.id"
          :nomcta="cuenta.nomcta"
          :nomcentro="centro.nombre"
          @toggleCuenta="toggleCuenta"
          @exit="exit"
          @getApiPresupuesto="getApiPresupuesto"
          :componenteVisible="componenteVisibleBorrador"
          :borrador="borrador" /> 
</div></div>
      </div>
      <div
        v-if="revisaExpansion(cuenta.id)"
        class="mt-0 p-4 bg-gray-50 border border-gray-200 text-sm 
               text-gray-700   shadow-sm animate-fadeIn"
      >
    
        <IngresosMensuales v-if="this.$store.state.auth.userLogin.modifica_presupuestos"
          :centro_id="centro.id"
          :propCuenta_id="cuenta.id"
          :nomcta="cuenta.nomcta"
          :nomcentro="centro.nombre"
          @toggleCuenta="toggleCuenta"
          @exit="exit"
          @getApiPresupuesto="getApiPresupuesto"
          :componenteVisible="componenteVisible"
          :borrador="borrador" /> 
          
       <IngresosMensualesSoloLectura v-else
          :centro_id="centro.id"
          :propCuenta_id="cuenta.id"
          :nomcta="cuenta.nomcta"
          :nomcentro="centro.nombre"
          @toggleCuenta="toggleCuenta"
          @exit="exit"
          @getApiPresupuesto="getApiPresupuesto"
          :componenteVisible="componenteVisible" />  
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
import api from "@/api/axios";
import IngresosMensuales from "./IngresosMensuales.vue";
import ModalLibroMayorDetalle from "../libromayor/ModalLibroMayorDetalle.vue"; 
import IngresosMensualesSoloLectura from "./IngresosMensualesSoloLectura.vue";
import IngresosMensualesBorrador from "./IngresosMensualesBorrador.vue";

export default {
  emits: ['toggleCuenta','toggleCuentaBorrador','reloadTotPresup'],
  props:
  {
    propCuenta: {
      type: Object
    },
    centro: {
      type: Object
    },
   
    cuentaExpandida: {
      type: Array
    },
    cuentaExpandidaBorrador: {
      type: Array
    },
    borrador:{
      type:Boolean

    }
  },
  data() {
    return {
      cuenta:{},
      cuenta_id: 0,
      modalVisible:false,
      componenteVisible:false,
      componenteVisibleBorrador:false,

      cuenta_total_presupuesto:0,
      datosFromModalIngreso:{},
      listDetalle:[],
      saldo:0,
      totalGastos:0,
      aa_consulta:0
      
    }
  },
  methods: {
     inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },
    toggleCuenta(id) {

      const i = this.cuentaExpandida.indexOf(id);
      if (i === -1) {
          console.log('esta oculta')
          this.componenteVisible=true;
      }
      this.$emit("toggleCuenta", id);
    },
    async getApiPresupuesto() 
    {
    this.$emit("reloadTotPresup",  this.cuenta.id   );
     

    },

    toggleCuentaBorrador(id) {

      const i = this.cuentaExpandidaBorrador.indexOf(id);
      if (i === -1) {
          this.componenteVisibleBorrador=true;
      }else{
          this.componenteVisibleBorrador=false;
      }
      
      this.$emit("toggleCuentaBorrador", id);
    },
  
    revisaExpansion(cuenta_id) {
    
      if (this.cuentaExpandida.includes(cuenta_id)) {
        return true;
      }
      return false;
    },
    revisaExpansionBorrador(cuenta_id) {
    
      if (this.cuentaExpandidaBorrador.includes(cuenta_id)) {
        return true;
      }
      return false;
    },
    exit(v){
        this.$emit("exit", v);
    },
    async editar() {

      try {

        const data = {
          cuenta_id: this.cuenta.id,
          centro_id: this.centro.id
        };
        if (this.borrador){
          data["borrador"] = this.borrador
        }
        const resp = await api.post(
          "/api/v1/presupuesto/gastos/",
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

        // ✅ petición exitosa
        this.listDetalle = resp.data.librosdetalles;

        this.totalGastos = this.listDetalle.reduce((acc, d) => {
          return acc + Number(d.total_gastos);
        }, 0);

        this.modalVisible = true;

      } catch (error) {
          console.log(error)
  
      }
    },
    
  },
  mounted() {
    this.inicializar()
    this.cuenta=this.propCuenta;
    const centrocuentas = this.$store.state.centrocuentas.visibilidad;
    const cuentavisible = centrocuentas.filter(cta => cta.visible && cta.id === this.cuenta.id && cta.centro === this.centro.id)
    if (Array.isArray(cuentavisible) && cuentavisible.length > 0) {
      this.componenteVisible=false;
    }
      
    this.cuenta_total_presupuesto= this.cuenta.total_presupuesto;
  },
  watch:{
     propCuenta: function(value){
       
        this.cuenta=value;
        this.cuenta_total_presupuesto = this.cuenta.total_presupuesto
      
     },
    
  },
  components: {
    IngresosMensuales ,
    IngresosMensualesSoloLectura ,
    ModalLibroMayorDetalle,
    IngresosMensualesBorrador
  },

}
</script>